import { useState } from "react";
import api from "./api";
import { Eye, EyeOff } from "lucide-react";

export default function Login({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await api.post("/api/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      onSuccess?.();
    } catch (e) {
      setErr(e?.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "Inter, sans-serif",
        background:
          "radial-gradient(circle at top right, #e8d9a1 0%, #bfa55b 25%, #222 80%)", // ✨ rich dark–gold gradient
        backgroundAttachment: "fixed",
        padding: "1rem",
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: "100%",
          maxWidth: 400,
          background: "rgba(255,255,255,0.95)",
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
          border: "1px solid rgba(255,215,100,0.3)",
          padding: "2rem 1.8rem",
          backdropFilter: "blur(6px)",
        }}
      >
        <h2
          style={{
            fontSize: "1.6rem",
            fontWeight: 800,
            marginBottom: "1.8rem",
            textAlign: "center",
            background:
              "linear-gradient(90deg, #b8860b, #d4af37, #f1c85b, #b8860b)",
            WebkitBackgroundClip: "text",
            color: "transparent",
          }}
        >
          Golden Arm Admin
        </h2>

        {err && (
          <p
            style={{
              color: "crimson",
              fontSize: 13,
              marginBottom: 12,
              textAlign: "center",
            }}
          >
            {err}
          </p>
        )}

        {/* Email */}
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="admin@example.com"
            required
            style={inputStyle}
          />
        </div>

        {/* Password */}
        <div style={{ marginBottom: 14, position: "relative" }}>
          <label style={labelStyle}>Password</label>
          <input
            type={showPass ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
            style={{ ...inputStyle, paddingRight: 36 }}
          />
          <span
            onClick={() => setShowPass(!showPass)}
            style={{
              position: "absolute",
              right: 10,
              top: 36,
              cursor: "pointer",
              color: "#777",
            }}
          >
            {showPass ? <EyeOff size={18} /> : <Eye size={18} />}
          </span>
        </div>

        {/* Forgot Password
        <div
          style={{
            textAlign: "right",
            marginBottom: 20,
            fontSize: 13,
          }}
        >
          <a
            href="#"
            style={{
              color: "#b8860b",
              textDecoration: "none",
              fontWeight: 500,
            }}
            onClick={(e) => e.preventDefault()}
          >
            Forgot Password?
          </a>
        </div> */}

        {/* Submit */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px 16px",
            background: loading
              ? "#ccc"
              : "linear-gradient(135deg,#b8860b,#d1b97a,#f1c85b)",
            color: "#111",
            fontWeight: 600,
            border: "none",
            borderRadius: 6,
            cursor: loading ? "not-allowed" : "pointer",
            transition: "0.3s ease",
          }}
        >
          {loading ? "Logging in..." : "Login"}
        </button>

        <p
          style={{
            marginTop: 24,
            fontSize: 12,
            color: "#777",
            textAlign: "center",
          }}
        >
          © {new Date().getFullYear()} Golden Arm Admin
        </p>
      </form>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #ccc",
  borderRadius: 6,
  fontSize: 14,
  outline: "none",
  backgroundColor: "#fff",
};

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 500,
  marginBottom: 4,
  color: "#333",
};
